export class CommentClassificationReferenceModel {
    public commentClassificationCode: string;
    public commentClassificationName: string;
    public statusCode: boolean;
}
